<template>
  <main id="create-quote-page" class="page-container">
    <!-- Messaggi di errore e successo -->
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p> -->

    <!-- Container in alto a destra per il pulsante toggle -->
    <!-- Bottone rimane invariato -->
    <div class="toggle-list-btn-container">
      <button
        @click="toggleItemsList"
        class="toggle-list-btn"
        :class="{ shifted: showItemsList }"
      >
        <img
          v-if="!showItemsList"
          :src="require('@/assets/plus_Icon.png')"
          alt="toggle-list"
          class="icon"
        />
        <img
          v-else
          :src="require('@/assets/minus_Icon.png')"
          alt="toggle-list"
          class="icon"
        />
        {{ showItemsList ? "Nascondi" : "Mostra" }} lista articoli
      </button>
    </div>

    <!-- Modale per lista articoli -->
    <VueFinalModal
      v-model="showItemsList"
      :clickToClose="true"
      :escToClose="true"
      classes="items-list-modal"
      content-class="items-list-modal-content"
    >
      <template #default>
        <button class="modal__close icons-button" @click="toggleItemsList">
          <i class="fa-solid fa-xmark"></i>
        </button>

        <h3 class="modal__title">Articoli aggiunti</h3>

        <div class="items-table-wrap">
          <table class="items-table" :style="{ '--item-col-w': itemColWidth }">
            <colgroup>
              <!-- 1) Articolo: dinamica in base ai caratteri -->
              <col :style="{ width: itemColWidth }" />
              <!-- 2) Le altre: lasciamo auto, garantiamo min-width via CSS -->
              <col />
              <col />
              <col />
              <col />
              <col />
              <col />
            </colgroup>
            <thead>
              <tr>
                <th>Articolo</th>
                <th>Categoria</th>
                <th>Quantità al Mq</th>
                <th>Quantità</th>
                <th>Venduti</th>
                <th>Prezzo unitario</th>
                <th>IVA</th>
                <th>Azione</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, idx) in formData.items"
                :key="
                  item.itemId
                    ? `stk-${item.itemId}-${item.iva}`
                    : `out-${item.outstockId}-${item.iva}`
                "
              >
                <td class="item-cell">
                  <div class="item-title">{{ itemDisplay(item).title }}</div>
                  <div v-if="itemDisplay(item).meta" class="item-meta">
                    {{ itemDisplay(item).meta }}
                  </div>
                </td>

                <td>
                  {{
                    getItemFromStore(
                      item.itemId || item.outstockId,
                      categoryHintForRow(item)
                    ).category
                  }}
                </td>

                <td
                  :class="[
                    'qty-cell',
                    { 'qty-editable': isOutstockTiles(item) },
                  ]"
                  @click="
                    isOutstockTiles(item) &&
                      editingQty.idx !== idx &&
                      startQtyEdit(idx, item.pieces || 0)
                  "
                  :title="
                    isOutstockTiles(item) ? 'Clicca per modificare i mq' : ''
                  "
                >
                  <input
                    v-if="editingQty.idx === idx && isOutstockTiles(item)"
                    :ref="`qtyInput_${idx}`"
                    type="number"
                    class="qty-input"
                    v-model.number="editingQty.value"
                    min="0.01"
                    step="any"
                    @input="updateQtyLive(idx, editingQty.value)"
                    @keydown.enter="closeQtyEdit"
                    @keydown.escape="cancelQtyEdit"
                    @blur="closeQtyEdit"
                  />
                  <span v-else>{{ mqCell(item) }}</span>
                </td>
                <td
                  :class="[
                    'qty-cell',
                    { 'qty-editable': qtyCell(item) !== '-' },
                  ]"
                  @click="
                    qtyCell(item) !== '-' &&
                      editingQty.idx !== idx &&
                      startQtyEdit(idx, qtyCell(item))
                  "
                  :title="
                    qtyCell(item) !== '-'
                      ? 'Clicca per modificare la quantità'
                      : ''
                  "
                >
                  <input
                    v-if="editingQty.idx === idx && !isOutstockTiles(item)"
                    :ref="`qtyInput_${idx}`"
                    type="number"
                    class="qty-input"
                    v-model.number="editingQty.value"
                    min="0.01"
                    step="any"
                    @input="updateQtyLive(idx, editingQty.value)"
                    @keydown.enter="closeQtyEdit"
                    @keydown.escape="cancelQtyEdit"
                    @blur="closeQtyEdit"
                  />
                  <span v-else>{{ qtyCell(item) }}</span>
                </td>
                <td class="venduti-cell">
                  <span
                    v-if="vendutiInfo(item).needsProcurement"
                    class="venduti venduti--procure"
                    :title="procureTitle(item)"
                  >
                    {{ vendutiInfo(item).sold }}
                    <span class="badge-procure"
                      >da ordinare {{ vendutiInfo(item).procure }}</span
                    >
                  </span>
                  <span v-else class="venduti">{{
                    vendutiInfo(item).sold
                  }}</span>
                </td>
                <td>{{ formatPrice(item.price) }} {{ unitForRow(item) }}</td>
                <td class="iva-cell">
                  <!-- sc-48743: IVA modificabile dalla riga, come la quantità -->
                  <AppSelect
                    class="iva-select"
                    :modelValue="Number(item.iva ?? 22)"
                    :options="aliquoteIvaOptions"
                    title="Cambia l'IVA della riga (il prezzo si ricalcola)"
                    ariaLabel="IVA della riga"
                    @change="updateRowIva(idx, $event)"
                  />
                </td>
                <td>
                  <button
                    class="icons-button"
                    @click="removeItem(idx)"
                    title="Rimuovi articolo dalla lista"
                    aria-label="Rimuovi articolo dalla lista"
                  >
                    <i class="fa-solid fa-trash"></i>
                  </button>
                </td>
              </tr>
              <tr v-if="formData.items.length === 0">
                <td colspan="8" class="no-result">Nessun articolo presente</td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
    </VueFinalModal>

    <!-- Modale per aggiunta nuovo articolo fuori magazzino -->
    <VueFinalModal
      v-model="showNewOutstockModal"
      :clickToClose="!creatingOutstock"
      :escToClose="!creatingOutstock"
      classes="documents-modal"
      content-class="confirm-modal-content"
    >
      <template #default>
        <button
          class="modal__close icons-button"
          @click="closeNewOutstockModal"
          :disabled="creatingOutstock"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>

        <h3 class="modal__title">Nuovo articolo fuori magazzino</h3>
        <div class="modal__subtitle" style="margin-bottom: 8px">
          Scegli la sottocategoria e compila i campi obbligatori.
        </div>

        <!-- SOTTOCATEGORIA -->
        <div class="field">
          <label>Sottocategoria</label>
          <AppSelect
            v-model="newOutstock.subCategory"
            :options="subCategoryOptions"
            placeholder="— scegli —"
          />
        </div>

        <!-- PIASTRELLE -->
        <template v-if="newOutstock.subCategory === 'piastrelle'">
          <div class="field">
            <label>Nome articolo *</label>
            <input
              type="text"
              v-model.trim="newOutstock.itemName"
              placeholder="es. Serie X Rovere"
            />
          </div>

          <div class="field">
            <label for="widthCm">Larghezza (cm)</label>
            <input
              id="widthCm"
              type="number"
              v-model.number="newOutstock.widthCm"
              min="1"
              step="1"
              placeholder="es. 50"
            />
          </div>

          <div class="field">
            <label for="heightCm">Altezza (cm)</label>
            <input
              id="heightCm"
              type="number"
              v-model.number="newOutstock.heightCm"
              min="1"
              step="1"
              placeholder="es. 50"
            />
          </div>

          <small v-if="tilesMeasurePreview" class="measure-preview">
            Anteprima misura: {{ tilesMeasurePreview }}
          </small>

          <div class="field">
            <label>Prezzo al Mq *</label>
            <input
              type="number"
              min="0"
              step="0.01"
              v-model.number="newOutstock.sqmPrice"
            />
          </div>
        </template>

        <!-- SANITARI / ALTRO -->
        <template
          v-else-if="
            newOutstock.subCategory === 'sanitari' ||
            newOutstock.subCategory === 'altro'
          "
        >
          <div class="field">
            <label>Brand</label>
            <input
              type="text"
              v-model.trim="newOutstock.brand"
              placeholder="es. Ideal Standard"
            />
          </div>
          <div class="field">
            <label>Modello</label>
            <input
              type="text"
              v-model.trim="newOutstock.subBrand"
              placeholder="es. Gran Bastardone"
            />
          </div>
          <!-- <div class="field">
            <label>Pezzi *</label>
            <input
              type="number"
              min="0"
              step="1"
              v-model.number="newOutstock.quantity"
            />
          </div> -->
          <div class="field">
            <label>Prezzo (€) *</label>
            <input
              type="number"
              min="0"
              step="0.01"
              v-model.number="newOutstock.price"
            />
          </div>
        </template>

        <div class="modal-actions">
          <button
            class="secondary-btn"
            @click="closeNewOutstockModal"
            :disabled="creatingOutstock"
          >
            Annulla
          </button>
          <button
            class="primary-btn confirm-btn"
            @click="createNewOutstock"
            :disabled="creatingOutstock || !isNewOutstockValid"
          >
            <span v-if="creatingOutstock">Salvo…</span>
            <span v-else>Salva</span>
          </button>
        </div>
      </template>
    </VueFinalModal>

    <!-- Modale DUPLICATO preventivo -->
    <VueFinalModal
      v-model="showDuplicateModal"
      :clickToClose="true"
      :escToClose="true"
      classes="documents-modal"
      content-class="confirm-modal-content dup-modal__content"
    >
      <template #default>
        <button class="modal__close icons-button" @click="closeDuplicateModal">
          <i class="fa-solid fa-xmark"></i>
        </button>

        <h3 class="modal__title">Preventivo già presente</h3>

        <p class="dup-modal__intro">
          Esiste già un preventivo per questo cliente allo stesso indirizzo in
          corso...
          <span
            v-if="lastDuplicateQuoteInfo?.address"
            class="dup-modal__address"
          >
            ({{ lastDuplicateQuoteInfo.address }}) </span
          >.
        </p>

        <!-- Stato: loading -->
        <div v-if="dupLoading" class="dup-modal__skeleton">
          Caricamento in corso…
        </div>

        <!-- Stato: errore -->
        <div v-else-if="dupError" class="dup-modal__error">
          {{ dupError }}
        </div>

        <!-- Stato: dati -->
        <div v-else-if="dupQuote" class="dup-quote">
          <div class="dup-quote__grid">
            <div>
              <div class="dup-quote__label">ID</div>
              <div class="dup-quote__value">#{{ dupQuote.id }}</div>
            </div>
            <div>
              <div class="dup-quote__label">Data</div>
              <div class="dup-quote__value">
                {{ formatToLocalDate(dupQuote.date) }}
              </div>
            </div>
            <div>
              <div class="dup-quote__label">Cliente</div>
              <div class="dup-quote__value">
                {{ dupQuote.clientName || "—" }}
              </div>
            </div>
            <div>
              <div class="dup-quote__label">Pagamento</div>
              <div class="dup-quote__value">{{ dupQuote.payment_method }}</div>
            </div>
            <div>
              <div class="dup-quote__label">Indirizzo</div>
              <div class="dup-quote__value">
                <a
                  v-if="dupQuote.location?.link"
                  :href="dupQuote.location.link"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="custom-link"
                >
                  {{ dupQuote.location?.address || "Vedi mappa" }}
                </a>
                <span v-else>{{ dupQuote.location?.address || "—" }}</span>
              </div>
            </div>
            <div>
              <div class="dup-quote__label">Totale</div>
              <div class="dup-quote__value">
                {{ money(dupQuote.totalPrice) }}
              </div>
            </div>
          </div>

          <div class="dup-quote__items">
            <div class="dup-quote__items-head">
              <strong>Riepilogo articoli</strong>
              <span class="muted">({{ dupQuote.items?.length || 0 }})</span>
            </div>
            <ul class="dup-quote__items-list">
              <li
                v-for="(it, idx) in dupQuote.items || []"
                :key="idx"
                class="dup-item"
              >
                <div class="dup-item__name">
                  {{ it.itemName || it.brand || "Articolo" }}
                </div>
                <div class="dup-item__meta">
                  <span v-if="it.category" class="chip">{{ it.category }}</span>
                  <span v-if="it.boxQuantity"
                    >scatole: {{ it.boxQuantity }}</span
                  >
                  <span v-if="it.pieces">pezzi: {{ it.pieces }}</span>
                  <span v-if="it.iva !== undefined">IVA: {{ it.iva }}%</span>
                  <span v-if="it.price !== undefined"
                    >€ {{ number(it.price) }}</span
                  >
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="dup-modal__footer">
          <!-- Apri file (si vede solo se ho caricato docs) -->
          <button
            v-if="dupQuote && !dupLoading && dupDocuments.length"
            class="btn-primary"
            @click="showDupDocs = true"
          >
            Apri file
          </button>
          <!-- <router-link
            v-if="lastDuplicateQuoteInfo?.quoteId"
            class="btn primary"
            :to="`/quote/${lastDuplicateQuoteInfo.quoteId}`"
            @click="onViewedExisting"
          >
            Apri preventivo esistente
          </router-link> -->

          <button class="btn-primary" @click="onChangeAddress">
            Usa indirizzo diverso
          </button>

          <button
            class="btn-ghost"
            :disabled="!lastDuplicateQuoteInfo?.quoteId"
            @click="onDuplicateWithEdit"
          >
            Duplica modificando indirizzo
          </button>
        </div>

        <!-- DEV: riquadro debug, rimuovi quando hai finito -->
        <!-- <div
          v-if="showDuplicateModal"
          style="margin-top: 12px; font-size: 12px; color: #555"
        >
          <details>
            <summary>Debug dup</summary>
            <pre style="white-space: pre-wrap; word-break: break-word">
lastDuplicateQuoteInfo: {{ lastDuplicateQuoteInfo }}
dupLoading: {{ dupLoading }}
dupError: {{ dupError }}
dupQuote: {{ dupQuote }}
    </pre
            >
          </details>
        </div> -->
      </template>
    </VueFinalModal>

    <VueFinalModal
      v-model="showDupDocs"
      :clickToClose="true"
      :escToClose="true"
      classes="documents-modal"
      content-class="documents-modal-content"
    >
      <template #default>
        <button class="modal__close icons-button" @click="showDupDocs = false">
          <i class="fa-solid fa-xmark"></i>
        </button>

        <h3 class="modal__title">Preventivo #{{ dupQuote?.id }}</h3>

        <div class="documents-grid">
          <div v-for="doc in dupDocuments" :key="doc.id" class="document-card">
            <a href="#" class="card-link" @click.prevent="openDoc(doc)">
              <div class="card-icon-pdf">
                <i class="fa-solid fa-file-pdf"></i>
              </div>
              <div class="card-body">
                <div class="card-title">{{ formatDocName(doc.name) }}</div>
                <div class="card-subtitle">
                  Data di creazione: {{ formatToLocalDate(doc.createdAt) }}
                </div>
              </div>
            </a>
          </div>

          <div v-if="dupDocuments.length === 0" class="no-result">
            Nessun documento trovato
          </div>
        </div>
      </template>
    </VueFinalModal>

    <!-- Form principale -->
    <form
      class="create-quote-form"
      @submit.prevent="onCreateQuoteAndGeneratePdf"
    >
      <!-- RIGA 1: Seleziona Cliente, data di inizio noleggio, data di fine noleggio e Operatore, Aggiungi Zona e categoria di articolo -->
      <div class="create-quote-row row-1">
        <!-- Seleziona Cliente -->
        <div class="field" id="client-select">
          <label>Cliente</label>
          <SearchableCombo
            v-model="formData.clientId"
            v-model:text="searchQueryClient"
            :items="comboClients"
            :labelKey="
              (c) =>
                c.email
                  ? `${c.clientName} - (${c.email})`
                  : `${c.clientName} - (${c.pec})`
            "
            :valueKey="(c) => c.id"
            placeholder="Cerca cliente..."
            :loading="clientsLoading"
            emptyText="Nessun risultato"
            @search="onSearchClient"
            @select="selectClient"
          />
        </div>

        <!-- Data Preventivo -->
        <div class="field">
          <label for="date">Data</label>
          <input
            id="date"
            type="datetime-local"
            v-model="formData.date"
            placeholder="Inserisci la data del preventivo..."
          />
        </div>
      </div>

      <div class="create-quote-row row-2">
        <!-- Indirizzo di consegna -->
        <div class="field">
          <label for="delivery-address">Indirizzo di consegna</label>
          <input
            type="text"
            v-model="formData.location.address"
            placeholder="Inserisci l'indirizzo completo di consegna"
            class="address-input"
          />
        </div>

        <!-- modalità di pagamento -->
        <div class="field">
          <label for="payment-method">Modalità di pagamento</label>
          <AppSelect
            id="payment-method"
            v-model="formData.payment_method"
            :options="paymentMethodOptions"
            placeholder="Seleziona modalità di pagamento..."
          />
        </div>
      </div>
      <hr />

      <!-- RIGA 3: scegli articolo, scegli quantità e prezzo, + bottone "aggiungi articolo" -->
      <div class="create-quote-row row-3">
        <!-- scegli Articolo -->
        <div class="field" id="item-select">
          <label for="item-search">Articolo</label>
          <SearchableCombo
            v-model="newItem.itemId"
            v-model:text="searchQueryItem"
            :items="filteredItems"
            :labelKey="itemPickerLabel"
            :valueKey="(it) => it.id"
            placeholder="Cerca articolo..."
            :disabled="isOutstockLocked"
            :loading="itemsLoading"
            emptyText="Nessun risultato"
            @search="onSearchItem"
            @select="selectItem"
          />
        </div>

        <!-- scegli eventuale Articolo fuori dal magazzino -->
        <div class="field" id="outstock-select">
          <label>Articolo fuori magazzino</label>
          <SearchableCombo
            v-model="newItem.outstockId"
            v-model:text="searchQueryOutstock"
            :items="filteredOutstock"
            :labelKey="(o) => nameForDisplay(o)"
            :valueKey="(o) => o.id"
            placeholder="Cerca articolo fuori magazzino..."
            :disabled="isStockLocked"
            :loading="outLoading"
            emptyText="Nessun risultato"
            @search="onSearchOutstock"
            @select="selectOutstock"
            @action="openNewOutstockModal"
          >
            <template #action>
              <i class="fa-solid fa-plus"></i>
            </template>
          </SearchableCombo>
        </div>

        <!-- Scegli Quantità -->
        <div class="field">
          <label :for="'quantity'">{{ quantityLabel }}</label>
          <input
            id="quantity"
            type="number"
            step="any"
            v-model="quantityInput"
            placeholder="Inserisci quantità"
          />
        </div>
        <!-- quantità al Mq => readonly -->
        <div class="field" v-if="showMqField">
          <label for="mq-per-box">Quantità al Mq</label>
          <input
            :value="mqPerQuantity"
            type="text"
            step="any"
            placeholder="Seleziona la quantità di scatole per visualizzare i mq"
            readonly
            class="readonly-field"
          />
        </div>
      </div>
      <div class="create-quote-row row-4">
        <!-- Scegli Prezzo -->
        <div class="field">
          <label for="price">Prezzo</label>
          <input
            id="price"
            type="number"
            v-model="newItem.price"
            placeholder="Seleziona l'articolo per visualizzare il prezzo corrispondente"
            step="0.01"
            readonly
            class="readonly-field"
          />
        </div>
        <!-- Scegli sconto su iva (opzionale) -->
        <div class="field">
          <label for="vat-rate">IVA</label>
          <AppSelect
            id="vat-rate"
            v-model="newItem.iva"
            :options="aliquoteIvaOptions"
          />
        </div>
      </div>

      <!-- RIGA 3: bottone "+ aggiungi articolo" -->
      <div class="create-quote-row row-5">
        <!-- Bottone per aggiungere un ulteriore alla lista -->
        <div class="field">
          <button type="button" class="add-item-btn" @click="addItem">
            <!-- icona -->
            <img
              :src="require('@/assets/plus_Icon.png')"
              alt="aggiungi"
              class="icon"
            />
            <span>aggiungi articolo</span>
          </button>
        </div>
      </div>
    </form>

    <hr />

    <!-- RIGA 6: note + cambio lingua -->
    <div class="create-quote-row row-5">
      <!-- Richieste tecniche -->
      <div class="field">
        <label for="technical-requests">Note</label>
        <textarea
          id="technical-requests"
          v-model.trim="formData.technical_queries"
          placeholder="Inserisci note"
          maxlength="2000"
        ></textarea>
      </div>
      <!-- Esempio di dropdown per il cambio lingua -->
      <!-- <div class="field">
        <label for="lang-select">Lingua PDF:</label>
        <select v-model="$i18n.locale" id="lang-select" class="pdf-lang-select">
          <option value="it">Italiano</option>
          <option value="en">English</option>
        </select>
      </div> -->
    </div>

    <!-- Bottone Salva allineato a destra -->
    <div class="save-button-container">
      <button
        id="save-quote-only"
        class="btn-secondary"
        @click="onCreateQuoteAndGeneratePdf({ sendEmail: false })"
        :disabled="!canSaveCreate"
        title="Salva preventivo ed esporta PDF"
      >
        Salva ed esporta PDF
      </button>

      <button
        id="send-quote-email"
        class="btn-primary"
        @click="onSendEmailOnly"
        :disabled="isDraftDirty || !lastUploadedDocName"
        :title="
          isDraftDirty
            ? 'Salva le modifiche prima di inviare'
            : !lastUploadedDocName
            ? 'Salva il preventivo prima di inviare'
            : 'Invia via email'
        "
        :class="{
          'btn-disabled-custom': isDraftDirty || !lastUploadedDocName,
        }"
      >
        <i class="fa-solid fa-envelope" style="margin-right: 8px"></i>
        Invia via email
      </button>
    </div>
  </main>
</template>

<script>
import logoPath from "@/assets/emmamaison.png";
// import crypto from "crypto";
import axiosInstance from "@/axiosInstance";
import { openDocument } from "@/utilities/openDocument";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import debounce from "lodash/debounce";
// import { nextTick } from "process";
import { mapActions } from "vuex/dist/vuex.cjs.js";
import { formatToLocalDate, toDateTimeLocal } from "../utilities/formatting";
import {
  itemFullDescription,
  itemPickerLabel,
  itemTitle,
  outstockName,
} from "../utilities/itemDescription";
import { pdfSafe, pdfSafeRows } from "../utilities/pdfText";
import {
  calcolaImporti,
  disegnaRiquadroRiepilogo,
  righeRiepilogo,
  totaliImponibile,
} from "../utilities/pdfRiepilogo";
import { splitQty } from "../utilities/procurement";
import { ALIQUOTE_IVA, prezzoConIva } from "../utilities/iva";
import SearchableCombo from "./SearchableCombo.vue";
// import DuplicateQuoteModal from "./DuplicateQuoteModal.vue";

// Chiavi cache namespaced: evitiamo collisioni tra items e outstocks con stessi id
const KEY = {
  STOCK: (id) => `STOCK:${Number(id)}`,
  OUT: (id) => `OUT:${Number(id)}`,
};

// 👇 helper per location: stringa JSON o oggetto
const asLoc = (raw) => {
  if (!raw) return null;
  if (typeof raw === "string") {
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }
  return raw; // è già un oggetto
};

export default {
  components: { SearchableCombo },
  beforeRouteLeave(to, from, next) {
    if (this.isAutoSavePending) {
      this.$toast.info("Sincronizzazione bozza in corso...");

      // Forza l'esecuzione immediata del debounce
      if (typeof this.debouncedAutoSave?.flush === "function") {
        this.debouncedAutoSave.flush();
      }

      const checkPending = setInterval(() => {
        if (!this.isAutoSavePending) {
          clearInterval(checkPending);
          next();
        }
      }, 100);

      setTimeout(() => {
        clearInterval(checkPending);
        if (this.isAutoSavePending) next();
      }, 3000);
    } else {
      next();
    }
  },

  async created() {
    this.$store
      .dispatch("fetchClients", {
        limit: 10000,
      })
      .catch((err) => {
        // evita Uncaught (in promise)
        console.error("Impossibile caricare i clienti: ", err.message);
        // puoi mostrare un toast o impostare un flag di errore
      });
    // this.$store.dispatch("fetchOperators");
    this.$store
      .dispatch("fetchItems", {
        limit: 10000,
      })
      .catch((err) => {
        // evita Uncaught (in promise)
        console.error("Impossibile caricare gli articoli: ", err.message);
        // puoi mostrare un toast o impostare un flag di errore
      });
    this.$store
      .dispatch("fetchOutstocks")
      .catch((err) =>
        console.error(
          "Impossibile caricare gli articoli fuori magazzino: ",
          err.message
        )
      );
    this.debouncedFetchItems = debounce(this.fetchItems, 200);
    this.debouncedFetchOutstocks = debounce(this.fetchOutstocks, 200);
    this.debouncedAutoSave = debounce(this.autoSaveDraft, 2500);

    // Se arrivo con un draftId nella query, lo recupero
    const qid = this.$route.query.draftId;
    if (qid) {
      this.draftId = Number(qid);
      await this.loadDraft(this.draftId);
    } else {
      // Nuovo preventivo: inizializza la data all'ora corrente
      this.formData.date = toDateTimeLocal(new Date());
    }
    this.isDraftDirty = false;
  },

  computed: {
    aliquoteIvaOptions() {
      return this.aliquoteIva.map((r) => ({ value: r, label: `${r}%` }));
    },
    clients() {
      return this.$store.getters["clients/list"] ?? [];
    },
    outstocks() {
      return this.$store.getters["outstocks/list"] ?? [];
    },
    selectedItem() {
      /* Se è stato scelto un articolo di magazzino */
      if (this.newItem.itemId) {
        return this.getItemFromStore(this.newItem.itemId, "STOCK"); // ← già fa cache
      }
      /* Se è stato scelto un articolo FUORI magazzino */
      if (this.newItem.outstockId) {
        return this.getItemFromStore(
          this.newItem.outstockId,
          "Fuori Magazzino"
        );
      }
      /* Nessuna selezione */
      return {};
    },
    quantityLabel() {
      if (this.selectedItem.category === "piastrelle")
        return "Quantità scatole";
      if (
        this.selectedItem.category === "Fuori Magazzino" &&
        this.selectedItem.subCategory === "piastrelle"
      )
        return "Quantità (mq)";
      if (this.selectedItem.category === "Fuori Magazzino") return "Quantità";
      return "Quantità pezzi";
    },

    /* Ponte per v-model quantityInput */
    quantityInput: {
      get() {
        return this.selectedItem.category === "piastrelle"
          ? this.newItem.boxQuantity // lavoro in scatole
          : this.newItem.pieces; // lavoro in pezzi
      },
      set(v) {
        const n = +v || 0;

        // piastrelle di MAGAZZINO → lavoro a scatole
        if (this.selectedItem.category === "piastrelle") {
          this.newItem.boxQuantity = n;
          const ppb = this.selectedItem.piecesPerBox || 1;
          this.newItem.pieces = n * ppb;
        } else {
          // sanitari / FUORI MAGAZZINO → lavoro a pezzi (per outstock piastrelle: i "pezzi" sono i mq)
          this.newItem.pieces = n;
        }
        // console.log("thisselecteditem", this.selectedItem);
        // FUORI MAGAZZINO: calcola TOTALE = unitPrice × qty
        if (this.selectedItem.category === "Fuori Magazzino") {
          const isTiles = this.selectedItem.subCategory === "piastrelle";
          const base = isTiles
            ? Number(this.selectedItem.sqmPrice) || 0
            : Number(this.selectedItem.price ?? this.newItem.unitPrice) || 0;

          const unit = Number(this.adjustedPrice(base, this.newItem.iva));
          this.newItem.unitPrice = unit;
          // this.newItem.pieces = n;

          const qty = this.newItem.pieces || 0; // per outstock uso sempre pieces (anche se "mq")
          this.newItem.price = (unit * qty).toFixed(2); // ← mostrato nel campo Prezzo
        }
      },
    },

    /* Ponte per v-model mqPerQuantity */
    mqPerQuantity() {
      const s = this.selectedItem || {};

      // Magazzino: piastrelle → scatole * mq per scatola
      if (s.category === "piastrelle") {
        const sqmPerBox = Number(s.sqmPerBox) || 0;
        const boxes = Number(this.newItem.boxQuantity) || 0;
        const total = boxes * sqmPerBox;
        return total ? total.toFixed(2) : "";
      }

      // Fuori magazzino: piastrelle → la quantità inserita è già in mq
      // if (s.category === "Fuori Magazzino" && s.subCategory === "piastrelle") {
      //   const sqm = Number(this.newItem.pieces) || 0; // usi 'pieces' come mq
      //   return sqm ? sqm.toFixed(2) : "";
      // }

      // Altri casi (sanitari/altro)
      return "";
    },

    showMqField() {
      const s = this.selectedItem || {};
      if (!s || !s.category) return false;
      if (s.category === "piastrelle") return true; // stock: piastrelle
      // if (s.category === "Fuori Magazzino")
      //   // outstock: piastrelle
      //   return s.subCategory === "piastrelle";
      return false; // sanitario, altro, ecc.
    },

    items() {
      return this.$store.getters["items/list"] ?? [];
    },

    filteredClients() {
      const query = (this.searchQueryClient || "").toLowerCase();
      // console.log("thisclients", this.clients);
      return this.clients
        .filter((c) => (c.clientName || "").toLowerCase().includes(query))
        .slice(0, 5);
    },

    // Tutti i nomi da mostrare nella colonna "Articolo"
    itemNames() {
      return (this.formData.items || []).map(
        (row) =>
          this.getItemName(
            row.itemId || row.outstockId,
            this.categoryHintForRow(row)
          ) || ""
      );
    },

    // Lunghezza massima in caratteri tra i nomi
    maxItemLen() {
      return this.itemNames.reduce((m, s) => Math.max(m, s.length), 0);
    },

    // Larghezza dinamica della colonna "Articolo" in ch, con limiti per non rompere il layout
    // - min 180px (leggibile anche con nomi brevi)
    // - valore centrale in ch (caratteri) = maxArtLen + 6 (un po' di respiro)
    // - max 52vw (mai oltre metà viewport nel modale)
    itemColWidth() {
      const ch = Math.max(10, Math.min(this.maxItemLen + 6, 72)); // clamp “logico”
      return `clamp(180px, ${ch}ch, 50vw)`;
    },

    isStockLocked() {
      return !!this.newItem.itemId;
    }, // blocca outstock se c'è un articolo
    isOutstockLocked() {
      return !!this.newItem.outstockId;
    }, // blocca articolo se c'è un outstock

    isNewOutstockValid() {
      const sub = (this.newOutstock.subCategory || "").toLowerCase();
      if (!sub) return false;

      const strOk = (v) => !!(v && v.toString().trim().length > 0);
      const numPos = (v) => Number.isFinite(+v) && +v > 0;
      const numOptPos = (v) =>
        v === "" || v === null || v === undefined || numPos(v);

      if (sub === "piastrelle") {
        const nameOk = strOk(this.newOutstock.itemName);
        const sqmOk = numPos(this.newOutstock.sqmPrice);
        const widthOk = numOptPos(this.newOutstock.widthCm);
        const heightOk = numOptPos(this.newOutstock.heightCm);
        return nameOk && sqmOk && widthOk && heightOk;
      }

      // sanitari / altro
      const brandOk = strOk(this.newOutstock.brand);
      const priceOk = numPos(this.newOutstock.price);
      return brandOk && priceOk;
    },

    tilesMeasurePreview() {
      if (this.newOutstock.subCategory !== "piastrelle") return "";
      const w = Number(this.newOutstock.widthCm);
      const h = Number(this.newOutstock.heightCm);
      if (Number.isFinite(w) && Number.isFinite(h) && w > 0 && h > 0) {
        return `${h}x${w} cm`;
      }
      return "";
    },

    isAddressValid() {
      return !!(this.formData.location?.address || "").trim();
    },
    canSaveCreate() {
      return this.formData.items.length > 0 && this.isAddressValid;
    },
  },
  data() {
    return {
      // loading per i 3 combobox
      clientsLoading: false,
      itemsLoading: false,
      outLoading: false,
      // lista clienti filtrata per il combobox (evitiamo il vecchio computed)
      comboClients: [],

      showDuplicateModal: false,
      lastDuplicateQuoteInfo: { quoteId: null, address: null },
      showDupDocs: false,
      dupDocuments: [],

      dupLoading: false,
      dupError: "",
      dupQuote: null,

      showDropdown: false,
      searchQueryClient: "",
      searchQueryItem: "",
      searchQueryOutstock: "",
      filteredItems: [],
      filteredOutstock: [],
      // selectedItemById: {}, // dizionario di cache locale
      selectedByKey: {}, // dizionario di cache locale (sia stock che outstock)
      showItemsList: false,
      selectedIndex: -1, // Indice dell'opzione attualmente evidenziata
      activeSearch: null, // "item" o "client" o null
      response: "",

      showNewOutstockModal: false,
      creatingOutstock: false,
      newOutstock: {
        subCategory: "", // ← nessuna scelta di default
        // piastrelle
        itemName: "",
        // sqmQuantity: null,
        sqmPrice: null,
        // sanitari/altro
        brand: "",
        subBrand: "",
        // quantity: null,
        price: null,
        widthCm: null,
        heightCm: null,
      },

      image: logoPath,
      formData: {
        location: {
          name: "",
          address: "",
        },
        technical_queries: "",
        clientId: "",
        outstockId: "",
        items: [],
        outstocks: [],
        date: "",
        payment_method: "",
      },
      newItem: {
        itemId: null,
        outstockId: null, // ← per articoli fuori magazzino
        boxQuantity: 0, // ← scatole, solo per piastrelle
        pieces: 0, // ← pezzi fisici (sanitari) o calcolati
        price: "",
        unitPrice: 0, // ← prezzo unitario per articoli fuori magazzino
        iva: 22,
      },
      errorMessage: "",
      successMessage: "",
      selectedPlaceId: "",
      // Draft state
      draftId: null,
      isSavingDraft: false,
      isAutoSavePending: false,
      needsReSave: false,
      isDraftDirty: false,
      editingQty: { idx: null, value: null, originalValue: null },
      aliquoteIva: ALIQUOTE_IVA, // sc-48743: form e righe usano le stesse
      subCategoryOptions: [
        { value: "piastrelle", label: "Piastrelle" },
        { value: "sanitari", label: "Sanitari" },
        { value: "altro", label: "Altro" },
      ],
      paymentMethodOptions: [
        { value: "Contanti", label: "Contanti" },
        { value: "Carta di credito", label: "Carta di credito" },
        { value: "Bonifico", label: "Bonifico" },
      ],
      isPdfGenerated: false, // Flag per tracciare se il PDF è stato generato post-salvataggio
      newQuoteId: null, // ID del preventivo creato
      lastUploadedDocName: null, // Nome del PDF caricato (usato per l'invio email separato)
    };
  },

  methods: {
    async openDoc(doc) {
      try {
        await openDocument(doc);
      } catch (err) {
        console.error("Errore nell'apertura del documento:", err);
        this.$toast.error("Impossibile aprire il documento");
      }
    },
    async onSendEmailOnly() {
      if (!this.newQuoteId || !this.lastUploadedDocName) {
        this.$toast.error("Salva il preventivo prima di inviare l'email");
        return;
      }
      if (this.isDraftDirty) {
        this.$toast.error(
          "Ci sono modifiche non salvate. Salva prima di inviare."
        );
        return;
      }
      const quoteClient =
        this.clients.find((c) => c.id === this.formData.clientId) || null;
      const contact = quoteClient?.pec || quoteClient?.email || "";
      try {
        this.$toast.info("Invio email al cliente...");
        await this.$store.dispatch("sendQuoteEmail", {
          quoteId: this.newQuoteId,
          objectName: this.lastUploadedDocName,
          contact,
        });
        if (contact) {
          this.$toast.success("Email inviata con successo!");
        } else {
          this.$toast.warning(
            "PDF caricato, ma il cliente non ha email o PEC: email non inviata."
          );
        }
        setTimeout(() => this.$router.push({ name: "quotes" }), 2000);
      } catch (err) {
        console.error("Errore invio email:", err);
        this.$toast.error(
          err.response?.data?.details ||
            err.response?.data?.error ||
            "Errore durante l'invio dell'email."
        );
      }
    },
    onSearchClient(q) {
      this.clientsLoading = true;
      const query = (q || "").toLowerCase();
      this.comboClients = (this.clients || [])
        .filter((c) => (c.clientName || "").toLowerCase().includes(query))
        .slice(0, 4);
      this.clientsLoading = false;
    },
    onSearchItem(q) {
      // campo vuoto: primi articoli (get-all senza filtro), non un elenco vuoto
      this.itemsLoading = true;
      this.debouncedFetchItems((q || "").trim());
    },
    onSearchOutstock(q) {
      this.outLoading = true;
      if (!q.trim()) {
        this.filteredOutstock = this.defaultOutstocks();
        this.outLoading = false;
        return;
      }
      this.debouncedFetchOutstocks(q);
    },

    async autoSaveDraft() {
      // Se non c'è nulla di utile nel form, non salvare (almeno un cliente o un articolo o indirizzo)
      const hasContent =
        this.formData.clientId ||
        this.formData.items.length > 0 ||
        (this.formData.location?.address || "").trim();

      if (!hasContent) return;
      if (this.isSavingDraft) {
        this.needsReSave = true;
        return;
      }
      this.needsReSave = false;
      this.isSavingDraft = true;

      try {
        // Otteniamo sempre il nome completo e aggiornato per il draft
        let draftClientName = this.searchQueryClient;
        if (this.formData.clientId) {
          const c = (this.clients || []).find(
            (x) => String(x.id) === String(this.formData.clientId)
          );
          if (c) {
            draftClientName = c.email
              ? `${c.clientName} - (${c.email})`
              : `${c.clientName} - (${c.pec})`;
            // Sincronizziamo anche l'interfaccia se necessario
            this.searchQueryClient = draftClientName;
          }
        }

        const payload = {
          payload: {
            ...this.formData,
            clientName: draftClientName, // per visualizzazione in lista bozze
          },
        };

        if (this.draftId) {
          await this.$axios.patch(`/draft/${this.draftId}`, payload);
        } else {
          const { data } = await this.$axios.post("/draft/create", payload);
          if (data.draft?.id) {
            this.draftId = data.draft.id;
            // Aggiorno la query senza ricaricare la pagina per mantenere il draftId nell'URL
            this.$router.replace({
              query: { ...this.$route.query, draftId: this.draftId },
            });
          }
        }
      } catch (err) {
        console.error("Errore auto-salvataggio bozza:", err);
      } finally {
        this.isSavingDraft = false;
        if (this.needsReSave) {
          this.autoSaveDraft();
        } else {
          this.isAutoSavePending = false;
        }
      }
    },
    handleBeforeUnload(event) {
      if (this.isAutoSavePending) {
        event.preventDefault();
        event.returnValue = "";
      }
    },

    async loadDraft(id) {
      this.clientsLoading = true;
      try {
        const { data } = await this.$axios.get(`/draft/${id}`);
        const draft = data.draft;
        if (draft && draft.payload) {
          // Uniamo il payload salvato con i dati di default per sicurezza
          this.formData = {
            ...this.formData,
            ...draft.payload,
          };
        }
      } catch (err) {
        this.$toast.error("Impossibile caricare la bozza");
        console.error(err);
      } finally {
        this.clientsLoading = false;
      }
    },

    async loadDuplicateQuote() {
      const id = this.lastDuplicateQuoteInfo?.quoteId;
      // console.debug("[dup] about to load", {
      //   lastDuplicateQuoteInfo: this.lastDuplicateQuoteInfo,
      //   id,
      // });
      if (!id) return;

      this.dupLoading = true;
      this.dupError = "";
      this.dupQuote = null;

      try {
        const { data } = await axiosInstance.get(`/quote/${id}`, {
          withCredentials: true,
        });
        // console.debug("[dup] GET /quote/:id response", data);

        // accetta sia {quote:{...}} sia {...} diretto
        const qRaw = data?.quote ?? data ?? {};
        // documents sia in quote che top-level
        this.dupDocuments = qRaw.documents ?? data?.documents ?? [];

        // parse location
        let parsedLocation = null;
        try {
          parsedLocation = asLoc(qRaw.location) || null;
        } catch {
          parsedLocation = null;
        }

        const items = (qRaw.quote_items || qRaw.items || []).map((qi) => {
          const fromStock = !!qi.item;
          const cat = fromStock ? qi.item.category : qi.outstock.category;
          return {
            category: cat,
            itemName: fromStock
              ? qi.item.itemName || qi.item.subBrand
              : outstockName(qi.outstock),
            brand: fromStock ? qi.item.subBrand : qi.outstock.brand,
            boxQuantity: fromStock && cat === "piastrelle" ? qi.quantity : 0,
            pieces: fromStock && cat === "piastrelle" ? 0 : qi.quantity,
            iva: qi.iva ?? 22,
            price: Number(qi.price ?? 0),
          };
        });

        this.dupQuote = {
          ...qRaw,
          location: parsedLocation,
          totalPrice: qRaw.totalPrice ?? data?.totalPrice ?? null,
          items,
        };

        // console.debug("[dup] normalized dupQuote", this.dupQuote);
      } catch (e) {
        // console.error("[dup] load error", e?.response || e);
        this.dupError =
          e?.response?.data?.message ||
          "Impossibile caricare il preventivo esistente.";
      } finally {
        this.dupLoading = false;
      }
    },

    openDuplicateModal(quoteId, address) {
      this.lastDuplicateQuoteInfo = {
        quoteId: quoteId ?? null,
        address: address ?? null,
      };
      this.dupError = "";
      this.dupQuote = null;
      this.showDuplicateModal = true;

      // 👇 evita di affidarti solo ai watcher
      if (this.lastDuplicateQuoteInfo.quoteId) {
        this.loadDuplicateQuote();
      }
    },

    closeDuplicateModal() {
      this.showDuplicateModal = false;
    },

    // util formattazioni (riusate nel template)
    number(v) {
      return (typeof v === "number" ? v : Number(v || 0)).toFixed(2);
    },
    money(v) {
      return `€ ${this.number(v)}`;
    },
    formatDocName(name) {
      return (
        (name ?? "")
          .toString()
          // prima togli eventuale ".dev" immediatamente prima di ".pdf"
          .replace(/\.dev(?=\.pdf$)/i, "")
          // poi rimuovi "_N_<numero>.pdf" in fondo
          .replace(/_N_\d+\.pdf$/i, "")
      );
    },
    formatToLocalDate,

    // azioni footer
    onChangeAddress() {
      this.showDuplicateModal = false;
      this.$nextTick(() => this.$refs.locationSearchBox?.focus());
    },
    async onDuplicateWithEdit() {
      const sourceId = this.lastDuplicateQuoteInfo?.quoteId;
      this.showDuplicateModal = false;

      if (!sourceId) return;

      try {
        // se il dettaglio non è già caricato, lo carico ora
        if (!this.dupQuote || this.dupQuote.id !== sourceId) {
          this.dupLoading = true;
          const { data } = await axiosInstance.get(`/quote/${sourceId}`, {
            withCredentials: true,
          });
          const loc = asLoc(data?.quote?.location);
          this.dupQuote = { ...data.quote, location: loc };
        }

        const q = this.dupQuote;

        // mappo le righe dal server -> formData.items
        const mappedItems = (q.quote_items || [])
          .map((qi) => {
            if (qi.item) {
              const cat = qi.item.category;
              return {
                itemId: qi.item.id,
                outstockId: null,
                boxQuantity: cat === "piastrelle" ? qi.quantity : 0,
                pieces: cat === "piastrelle" ? 0 : qi.quantity,
                price: Number(qi.price).toFixed(2),
                iva: qi.iva ?? 22,
              };
            }
            if (qi.outstock) {
              return {
                itemId: null,
                outstockId: qi.outstock.id,
                boxQuantity: 0,
                pieces: qi.quantity, // mq per piastrelle outstock, pezzi per altri
                price: Number(qi.price).toFixed(2),
                iva: qi.iva ?? 22,
              };
            }
            return null;
          })
          .filter(Boolean);

        // cache per etichette/nomi in tabella
        (q.quote_items || []).forEach((qi) => {
          // if (qi.item) this.selectedItemById[qi.item.id] = qi.item;
          // if (qi.outstock) this.selectedItemById[qi.outstock.id] = qi.outstock;
          if (qi.item) this.selectedByKey[KEY.STOCK(qi.item.id)] = qi.item;
          if (qi.outstock)
            this.selectedByKey[KEY.OUT(qi.outstock.id)] = qi.outstock;
        });

        // compilo la form con i dati del preventivo esistente
        this.formData = {
          ...this.formData,
          clientId: q.clientId,
          payment_method: q.payment_method || "",
          technical_queries: q.technical_queries || "",
          items: mappedItems,
          outstockId: "",
          location: {
            name: "",
            address: "",
          }, // ← SVUOTO
        };

        this.newItem = this.resetNewItem();

        this.$nextTick(() => {
          this.$refs.locationSearchBox?.focus();
        });
        this.$toast.info(
          `Contenuto del preventivo #${q.id} copiato. Inserisci un indirizzo diverso e salva.`
        );
      } catch (e) {
        this.$toast.error("Impossibile duplicare questo preventivo ora.");
      } finally {
        this.dupLoading = false;
      }
    },
    onViewedExisting() {
      // opzionale: analytics/log
    },

    defaultOutstocks(n = 10) {
      return (this.outstocks || []).slice(0, n);
    },

    categoryHintForRow(row) {
      // Se ho un outstockId → è indubbiamente FUORI MAGAZZINO
      if (row?.outstockId) return "Fuori Magazzino";
      // Se la riga ha già category salvata, usala
      if (row?.category) return row.category;
      // Altrimenti assumo stock
      return "STOCK";
    },

    isOutstockTiles(row) {
      const it = this.getItemFromStore(
        row.itemId || row.outstockId,
        this.categoryHintForRow(row)
      );
      return (
        it &&
        it.category === "Fuori Magazzino" &&
        it.subCategory === "piastrelle"
      );
    },
    isStockTiles(row) {
      const it = this.getItemFromStore(
        row.itemId || row.outstockId,
        this.categoryHintForRow(row)
      );
      return it && it.category === "piastrelle";
    },
    qtyCell(row) {
      // Outstock piastrelle → nessuna quantità in pezzi/scatole da mostrare
      if (this.isOutstockTiles(row)) return "-"; // oppure "N/D"
      // Magazzino piastrelle → mostro le SCATOLE
      if (this.isStockTiles(row)) return Number(row.boxQuantity || 0);
      // Sanitari/altro → mostro i PEZZI
      return Number(row.pieces || row.quantity || 0);
    },

    // Anteprima "Venduti" (sc-47204): quantità venduta nativa + split magazzino/
    // da ordinare calcolato client-side (lo split autoritativo è ricalcolato dal
    // server al salvataggio). In creazione lo stock dello store è "fresco".
    // Per i fuori magazzino non esiste una quota "da magazzino": tutto è da
    // ordinare al fornitore, quindi il "0 da magazzino" sarebbe fuorviante.
    procureTitle(row) {
      const info = this.vendutiInfo(row);
      return row.outstockId
        ? `Fuori magazzino: ${info.procure} da ordinare al fornitore`
        : `${info.warehouse} da magazzino + ${info.procure} da ordinare`;
    },

    vendutiInfo(row) {
      // Fuori magazzino → nessuna disponibilità, tutto da ordinare
      if (row.outstockId) {
        const sold = Number(row.pieces || row.quantity || 0);
        return {
          sold,
          warehouse: 0,
          procure: sold,
          needsProcurement: sold > 0,
        };
      }
      const it =
        this.getItemFromStore(row.itemId, this.categoryHintForRow(row)) || {};
      const isTiles = it.category === "piastrelle";
      const sold = isTiles
        ? Number(row.boxQuantity || 0)
        : Number(row.pieces || row.quantity || 0);
      const available = isTiles
        ? Number(it.boxQuantity || 0)
        : Number(it.inWarehouse || 0);
      return { sold, ...splitQty(sold, available) };
    },
    mqCell(row) {
      const it =
        this.getItemFromStore(
          row.itemId || row.outstockId,
          this.categoryHintForRow(row)
        ) || {};
      // Magazzino piastrelle → scatole × mqPerBox
      if (this.isStockTiles(row)) {
        const sqmPerBox = Number(it.sqmPerBox) || 0;
        const boxes = Number(row.boxQuantity) || 0;
        const total = boxes * sqmPerBox;
        return total ? total.toFixed(2) : "N/D";
      }
      // Fuori magazzino piastrelle → i mq coincidono con 'pieces'
      if (this.isOutstockTiles(row)) {
        const sqm = Number(row.pieces) || 0;
        return sqm ? sqm.toFixed(2) : "N/D";
      }
      // Altri casi → non applicabile
      return "N/D";
    },

    getItemFromStore(id, categoryHint) {
      if (!id) return {};

      // 0) normalizza hint
      const isOut =
        categoryHint === "Fuori Magazzino" ||
        categoryHint === "OUT" ||
        categoryHint === "out" ||
        categoryHint === "outstock";

      const key = isOut ? KEY.OUT(id) : KEY.STOCK(id);

      // 1) cache namespaced
      if (this.selectedByKey[key]) return this.selectedByKey[key];

      // 2) cerca SOLO dove ha senso
      if (isOut) {
        // FUORI MAGAZZINO
        const out =
          (this.outstocks || []).find((o) => o.id === id) ||
          (this.filteredOutstock || []).find((o) => o.id === id);
        if (out) {
          this.selectedByKey[key] = out;
          return out;
        }
        return {};
      }

      // STOCK
      const stk =
        (this.items || []).find((i) => i.id === id) ||
        (this.filteredItems || []).find((i) => i.id === id);
      if (stk) {
        this.selectedByKey[key] = stk;
        return stk;
      }
      return {};
    },

    // Mappa l'azione createItem dallo store
    ...mapActions(["uploadQuoteDocument", "sendQuoteEmail"]),

    toggleItemsList() {
      this.showItemsList = !this.showItemsList;
    },

    startSearch(type) {
      this.activeSearch = type; // 'client' o 'item'
      this.showDropdown = true;
      this.selectedIndex = -1;
      // azzera solo il campo “attivo”
      if (type === "client") this.searchQueryClient = "";
      if (type === "item") this.searchQueryItem = "";

      if (type === "outstock") {
        // if (this.newItem.outstockId || this.formData.outstockId) {
        // this.clearOutstockSelection();
        // se vuoi forzare il fetch da API:
        // this.$store.dispatch("fetchOutstocks").finally(() => {
        //   this.filteredOutstock = this.defaultOutstocks();
        // });
        // }
        this.filteredOutstock = this.defaultOutstocks();
      }
    },

    handleKey(event) {
      if (!this.showDropdown) return;

      // Quale array devo navigare?
      let list;
      if (this.activeSearch === "client") {
        list = this.filteredClients;
      } else if (this.activeSearch === "item") {
        list = this.filteredItems;
      } else if (this.activeSearch === "outstock") {
        list = this.filteredOutstock; // o filteredOutstock se disponibile
      } else {
        list = [];
      }

      // ========== freccia giù ==========
      if (event.key === "ArrowDown") {
        this.selectedIndex =
          this.selectedIndex < list.length - 1 ? this.selectedIndex + 1 : 0;
        event.preventDefault();

        // ========== freccia su ==========
      } else if (event.key === "ArrowUp") {
        this.selectedIndex =
          this.selectedIndex > 0 ? this.selectedIndex - 1 : list.length - 1;
        event.preventDefault();

        // ========== ENTER ==========
      } else if (event.key === "Enter") {
        if (this.selectedIndex >= 0 && this.selectedIndex < list.length) {
          const chosen = list[this.selectedIndex];

          if (this.activeSearch === "client") {
            // selezione cliente
            this.formData.clientId = chosen.id;
            this.searchQueryClient = chosen.clientName;
          } else if (this.activeSearch === "item") {
            // selezione articolo
            this.newItem.itemId = chosen.id;
            this.searchQueryItem = itemPickerLabel(chosen);
            this.newItem.price = this.adjustedPrice(
              chosen.price,
              this.newItem.iva
            );
            // memorizza l'oggetto articolo completo
            // this.selectedItemById[chosen.id] = chosen;
            this.selectedByKey[KEY.STOCK(chosen.id)] = chosen;
          } else {
            // selezione articolo fuori magazzino
            this.newItem.outstockId = chosen.id;
            // console.log("selected outstock: ", chosen);
            this.searchQueryOutstock = outstockName(chosen);

            this.selectedByKey[KEY.OUT(chosen.id)] = chosen;
          }
          this.showDropdown = false;
          this.selectedIndex = -1;
        }
        event.preventDefault();
      }
    },

    selectClient(client) {
      this.formData.clientId = client.id;
      // Lasciamo che v-model:text gestisca la sincronizzazione automatica del testo
      // se l'utente clicca, il componente aggiornerà searchQueryClient tramite update:text
      this.hideDropdown();
    },
    selectItem(item) {
      this.newItem.itemId = item.id;
      this.newItem.outstockId = null; // 👈 reset
      this.searchQueryItem = itemPickerLabel(item);
      // const item =
      // memorizza l'oggetto articolo completo
      // this.selectedItemById[item.id] = item;
      this.selectedByKey[KEY.STOCK(item.id)] = item;
      // prendo il prezzo “stockato” e lo metto in newItem.price
      this.newItem.price = this.adjustedPrice(item.price, this.newItem.iva);
      this.hideDropdown();
    },

    selectOutstock(outstock) {
      // this.formData.outstockId = outstock.id;
      this.newItem.outstockId = outstock.id;
      this.newItem.itemId = null;

      // unitario di partenza (22%) → poi lo adeguo all'IVA selezionata
      const base =
        outstock.subCategory === "piastrelle"
          ? Number(outstock.sqmPrice) || 0
          : Number(outstock.price) || 0;

      this.newItem.unitPrice = Number(
        this.adjustedPrice(base, this.newItem.iva)
      );

      // qty corrente (probabilmente 0)
      const qtyNow = this.newItem.pieces || 0;
      this.newItem.price = (this.newItem.unitPrice * qtyNow).toFixed(2);

      this.searchQueryOutstock =
        outstock.subCategory === "piastrelle"
          ? [outstock.itemName, outstock.measureDesc].filter(Boolean).join(" ")
          : outstockName(outstock);

      // this.selectedItemById[outstock.id] = outstock;
      this.selectedByKey[KEY.OUT(outstock.id)] = outstock;
      this.hideDropdown();
    },

    handleOutstockSelection() {
      this.hideDropdown();
      const id = this.newItem.outstockId;
      const outstock = this.getItemFromStore(id, "Fuori Magazzino"); // 👈
      if (outstock && outstock.id) this.selectOutstock(outstock);
    },

    openNewOutstockModal() {
      this.showNewOutstockModal = true;
    },
    closeNewOutstockModal() {
      // if (this.creatingOutstock) return;
      this.showNewOutstockModal = false;
      this.newOutstock = {
        subCategory: "",
        itemName: "",
        // sqmQuantity: null,
        sqmPrice: null,
        brand: "",
        // quantity: null,
        price: null,
        widthCm: null,
        heightCm: null,
      };
    },

    async createNewOutstock() {
      const sub = this.newOutstock.subCategory;
      if (!this.isNewOutstockValid) {
        this.$toast.error("Compila correttamente i campi obbligatori.");
        return;
      }

      const isTiles = sub === "piastrelle";

      // 🔢 prendi width/height come numeri (0 se vuoti)
      const w = Number(this.newOutstock.widthCm) || 0;
      const h = Number(this.newOutstock.heightCm) || 0;

      // 🧱 payload robusto
      const payload = {
        category: "Fuori Magazzino",
        subCategory: sub,
        ...(isTiles
          ? {
              itemName: (this.newOutstock.itemName || "").trim(),
              sqmQuantity: 0,
              sqmPrice: Number(this.newOutstock.sqmPrice),
              // 👉 passa SEMPRE le misure se >0
              ...(w > 0 && h > 0 ? { widthCm: w, heightCm: h } : {}),
              // 👉 passa anche measureDesc lato FE per sicurezza
              ...(w > 0 && h > 0 ? { measureDesc: `${h}x${w} cm` } : {}),
            }
          : {
              brand: (this.newOutstock.brand || "").trim(),
              subBrand: (this.newOutstock.subBrand || "").trim(),
              quantity: 0,
              price: Number(this.newOutstock.price),
            }),
      };

      this.creatingOutstock = true;
      try {
        let res;
        if (this.$store._actions?.createOutstock) {
          res = await this.$store.dispatch("createOutstock", payload);
        } else {
          res = await this.$axios.post(
            "outstock/create",
            JSON.stringify(payload)
          );
        }

        // 🔎 normalizza sempre l’oggetto creato
        const created =
          res?.data?.outstock ??
          res?.data?.outstock?.dataValues ?? // in caso di Sequelize
          res?.data ??
          {};

        const createdId = Number(created.id) || null;

        // ✅ seleziona SUBITO quello creato, senza aspettare il refetch
        if (createdId) {
          this.selectedByKey[KEY.OUT(createdId)] = created;
          this.selectOutstock(created); // imposta v-models e prezzo
        } else {
          // fallback (in casi estremi)
          await this.$store.dispatch("fetchOutstocks");
          const fresh = (this.outstocks || []).find((o) =>
            isTiles
              ? (o.itemName || "") === (payload.itemName || "") &&
                Number(o.sqmPrice) === Number(payload.sqmPrice)
              : (o.brand || "") === (payload.brand || "") &&
                Number(o.price) === Number(payload.price)
          );
          if (fresh) {
            this.selectedByKey[KEY.OUT(fresh.id)] = fresh;
            this.selectOutstock(fresh);
          }
        }

        this.$toast.success("Articolo fuori magazzino creato!");
        this.closeNewOutstockModal();
        this.$nextTick(() =>
          setTimeout(() => this.$refs.outstockInput?.focus(), 0)
        );

        // opzionale: refresh in background (non blocca l’UI)
        this.$store.dispatch("fetchOutstocks").catch(() => {});
      } catch (err) {
        const msg =
          err?.response?.data?.details ||
          err?.response?.data?.error ||
          err?.message ||
          "Impossibile creare l’articolo.";
        this.$toast.error(msg);
      } finally {
        this.creatingOutstock = false;
      }
    },

    hideDropdown() {
      setTimeout(() => {
        this.showDropdown = false;
        this.selectedIndex = -1;
        this.activeSearch = null;
      }, 300);
    },

    nameForDisplay(src) {
      return this.itemDisplayFromObj(src || {}).title || "Sconosciuto";
    },

    // Esposto al template per il menu di selezione articolo (sc-48197)
    itemPickerLabel,

    /**
     * Gestisce la selezione di un cliente dal dropdown.
     * Chiude il dropdown e aggiorna la searchQueryClient con il nome del cliente selezionato.
     */
    handleClientSelection() {
      this.showDropdown = false;
      this.searchQueryClient = this.getClientName(this.formData.clientId);
    },

    /* prende il prezzo dal DB (22% già incluso) e, se l’utente ha scelto 10 o 4,
     ricalcola in presa diretta */
    adjustedPrice(listino, rate) {
      if (rate === 22) return listino;
      const regularPrice = (listino / 1.22).toFixed(2);
      const prezzoIvato = (regularPrice * (1 + rate / 100)).toFixed(2);
      return prezzoIvato;
    },

    async onSelectItem() {
      // 1) hide dropdown
      this.hideDropdown();
      // console.log("newitem", this.newItem);
      // 2) trova l'item selezionato
      const item = this.getItemFromStore(this.newItem.itemId, "STOCK");
      if (!item.id) return;

      // memorizza l'oggetto articolo completo
      // this.selectedItemById[item.id] = item;
      this.selectedByKey[KEY.STOCK(item.id)] = item;
      // 3) aggiorna la searchQuery per mostrare il nome selezionato
      this.searchQueryItem = itemPickerLabel(item);

      // 4) popola il prezzo
      this.newItem.price = this.adjustedPrice(item.price, this.newItem.iva);
    },

    addItem() {
      this.errorMessage = "";
      this.successMessage = "";

      /* 1️⃣  identifica il tipo */
      const isTile = this.selectedItem.category === "piastrelle";
      const isOutstock = !!this.newItem.outstockId;
      const selected = this.selectedItem;

      // stock piastrelle: qty = scatole; tutti gli altri (incluso outstock piastrelle): qty = pieces (mq o pezzi)
      const qty = isTile
        ? Number(this.newItem.boxQuantity || 0)
        : Number(this.newItem.pieces || 0);

      /* 2️⃣  validazione campi minimi */
      if (
        (!this.newItem.itemId && !isOutstock) ||
        qty <= 0 ||
        !this.newItem.price
      ) {
        this.errorMessage =
          "Compila tutti i campi prima di aggiungere un articolo.";
        this.$toast.error(this.errorMessage);
        return;
      }

      /* 3️⃣  cache locale dell’oggetto selezionato */
      // const cacheId = isOutstock
      //   ? this.newItem.outstockId
      //   : this.newItem.itemId;
      // const fullObj = this.selectedItem;
      // if (cacheId && fullObj.id) this.selectedItemById[cacheId] = fullObj;

      const fullObj = this.selectedItem;
      if (fullObj?.id) {
        if (isOutstock) {
          this.selectedByKey[KEY.OUT(fullObj.id)] = fullObj;
        } else {
          this.selectedByKey[KEY.STOCK(fullObj.id)] = fullObj;
        }
      }

      /* verifica se la riga esiste già (stesso articolo + stesso prezzo + iva) */
      /* esiste già una riga con lo stesso articolo?  */
      const existing = this.formData.items.find(
        (r) =>
          r.itemId === this.newItem.itemId &&
          r.outstockId === this.newItem.outstockId &&
          r.iva === this.newItem.iva
      );

      if (existing) {
        /* --- aggiornamento --- */
        if (isTile) {
          existing.boxQuantity = this.newItem.boxQuantity;
          existing.pieces = 0;
        } else {
          // sanitari o fuori-magazzino
          existing.pieces = this.newItem.pieces;
        }
        /* ricalcola il totale: unitPrice × nuova qty      */
        // if (isOutstock) {
        //   const unit = this.newItem.unitPrice; // è già numerico
        //   existing.price = (unit * existing.pieces).toFixed(2);
        // } else {
        //   existing.price = this.newItem.price; // sanitari o piastrelle
        // }
        if (isOutstock) {
          existing.price = Number(this.newItem.unitPrice).toFixed(2); // unitario
        } else {
          existing.price = this.newItem.price; // magazzino
        }

        existing.iva = this.newItem.iva;

        this.$nextTick(() => {
          this.successMessage = "Quantità aggiornata per l'articolo esistente.";
          this.$toast.success(this.successMessage);
        });
        return; // niente push()
      }

      /* 5️⃣  altrimenti pusha una nuova riga */
      this.formData.items.push({
        itemId: this.newItem.itemId ?? null,
        outstockId: this.newItem.outstockId ?? null,
        boxQuantity: this.newItem.boxQuantity,
        pieces: this.newItem.pieces,
        // price: this.newItem.price, // già TOT per outstock
        price: isOutstock
          ? Number(this.newItem.unitPrice).toFixed(2)
          : this.newItem.price,
        iva: this.newItem.iva,
        category:
          selected.category || (isOutstock ? "Fuori Magazzino" : "STOCK"),
      });
      // console.log("formData.items: ", this.formData.items);
      this.$nextTick(() => {
        this.successMessage = "Articolo aggiunto con successo.";
        this.$toast.success(this.successMessage);
      });
      /* 6️⃣  reset campi input */
      this.newItem = {
        itemId: null,
        outstockId: null,
        boxQuantity: 0,
        pieces: 0,
        price: "",
        unitPrice: 0,
        iva: 22,
        category: "",
      };
      this.searchQueryItem = "";
      this.searchQueryOutstock = "";
      this.showDropdown = false;
    },

    // sc-48743: cambio IVA dalla riga. Il prezzo unitario ivato si ricalcola
    // a parità di imponibile, come fa il form quando si sceglie l'aliquota.
    updateRowIva(idx, rawValue) {
      const nuova = Number(rawValue);
      const item = { ...this.formData.items[idx] };
      const attuale = Number(item.iva ?? 22);
      if (!ALIQUOTE_IVA.includes(nuova) || nuova === attuale) return;
      const prezzo = prezzoConIva(item.unitPrice ?? item.price, attuale, nuova);
      item.iva = nuova;
      item.price = prezzo;
      if (item.unitPrice !== undefined) item.unitPrice = prezzo;
      this.formData.items.splice(idx, 1, item);
    },

    removeItem(index) {
      this.formData.items.splice(index, 1);
    },

    startQtyEdit(idx, currentValue) {
      const orig = Number(currentValue);
      this.editingQty = { idx, value: orig, originalValue: orig };
      this.$nextTick(() => {
        const ref = this.$refs[`qtyInput_${idx}`];
        const el = Array.isArray(ref) ? ref[0] : ref;
        if (el && typeof el.focus === "function") el.focus();
      });
    },

    updateQtyLive(idx, rawValue) {
      const val = parseFloat(rawValue);
      if (isNaN(val) || val <= 0) return;
      const item = { ...this.formData.items[idx] };
      if (this.isStockTiles(item)) {
        item.boxQuantity = val;
      } else {
        item.pieces = val;
      }
      this.formData.items.splice(idx, 1, item);
    },

    closeQtyEdit() {
      this.editingQty = { idx: null, value: null, originalValue: null };
    },

    cancelQtyEdit() {
      const { idx, originalValue } = this.editingQty;
      if (idx !== null && originalValue !== null) {
        const item = { ...this.formData.items[idx] };
        if (this.isStockTiles(item)) {
          item.boxQuantity = originalValue;
        } else {
          item.pieces = originalValue;
        }
        this.formData.items.splice(idx, 1, item);
      }
      this.editingQty = { idx: null, value: null, originalValue: null };
    },

    saveToLocalStorage(key, data) {
      localStorage.setItem(key, JSON.stringify(data));
    },

    loadFromLocalStorage(key) {
      const savedData = localStorage.getItem(key);
      if (savedData) {
        return JSON.parse(savedData);
      }
      return null;
    },

    cap(w) {
      const s = (w || "").toString().trim();
      return s ? s[0].toUpperCase() + s.slice(1).toLowerCase() : "";
    },

    itemDisplay(row) {
      const it =
        this.getItemFromStore(
          row.itemId || row.outstockId,
          this.categoryHintForRow(row)
        ) || {};
      return this.itemDisplayFromObj(it);
    },

    // Usa la stessa logica di itemDisplay ma partendo da id+categoria
    itemDisplayById(id, categoryHint) {
      const it = this.getItemFromStore(id, categoryHint) || {};
      // riusa la parte di formattazione dentro itemDisplay:
      // copiamo la stessa logica in una funzione dedicata
      return this.itemDisplayFromObj(it);
    },

    // Estrae { title, meta } da un oggetto item già risolto
    itemDisplayFromObj(it = {}) {
      const Cap = (s) =>
        (s || "")
          .toString()
          .trim()
          .replace(/^\w/, (c) => c.toUpperCase());

      // Il titolo e' composto da itemTitle(): regola unica per UI e PDF (sc-48197)
      const title = itemTitle(it);

      // ---- PIASTRELLE STOCK ----
      if (it.category === "piastrelle") {
        // meta: prima measureDesc, altrimenti width×height cm se presenti
        const meta =
          it.measureDesc ||
          (it.widthCm && it.heightCm ? `${it.widthCm}×${it.heightCm} cm` : "");
        return { title: title || "Articolo", meta };
      }

      // ---- FUORI MAGAZZINO: PIASTRELLE ----
      if (
        it.category === "Fuori Magazzino" &&
        it.subCategory === "piastrelle"
      ) {
        return {
          title,
          meta: "Piastrelle",
        };
      }

      // ---- SANITARI / ALTRO (stock o fuori magazzino) ----

      const T = Cap(it.fixtureType || "");
      const P =
        it.fixturePosition === "terra"
          ? "a terra"
          : Cap(it.fixturePosition || "");

      // se ho info di tipo/posizione le mostro; altrimenti fallback alla subCategory (es. "Sanitari"/"Altro")
      const metaParts = [T, P].filter(Boolean);
      const meta = metaParts.length
        ? metaParts.join(" ")
        : Cap(it.subCategory || "");

      return { title, meta };
    },

    // ⚠️ Back-compat: ora usa la nuova formattazione e restituisce solo il titolo
    getItemName(id, categoryHint) {
      return this.itemDisplayById(id, categoryHint).title;
    },

    getClientName(clientId) {
      const client = this.clients.find((c) => c.id === clientId);
      return client ? client.clientName : "Sconosciuto";
    },

    formatPrice(price) {
      const currencySymbol = "€"; // Cambia in "$" per il dollaro
      return `${currencySymbol} ${parseFloat(price).toFixed(2)}`;
    },

    unitForRow(row) {
      const it =
        this.getItemFromStore(
          row.itemId || row.outstockId,
          this.categoryHintForRow(row)
        ) || {};
      const isStockTiles = it.category === "piastrelle";
      const isOutTiles =
        it.category === "Fuori Magazzino" && it.subCategory === "piastrelle";
      if (
        String(row?.itemName || it?.itemName || "")
          .toLowerCase()
          .includes("battiscopa")
      )
        return "€/mL";
      return isStockTiles || isOutTiles ? "€/mq" : "€/pz";
    },

    mqForRow(row) {
      // console.log("row", row);
      const item = this.getItemFromStore(
        row.itemId || row.outstockId,
        this.categoryHintForRow(row)
      );
      // console.log("mqForRow item: ", item);
      if (item.category !== "piastrelle" && item.subCategory === "piastrelle") {
        return row.pieces || 0;
      }
      const sqmPerBox = Number(item.sqmPerBox) || 0;
      const boxes = Number(row.boxQuantity) || 0;
      const total = sqmPerBox * boxes;
      return total ? total.toFixed(2) : "";
    },

    resetNewItem() {
      return {
        itemId: null,
        outstockId: null,
        boxQuantity: 0,
        pieces: 0,
        price: "",
        unitPrice: 0, // prezzo unitario per articoli fuori magazzino
        category: "",
        quantity: 0, // quantità pezzi per articoli fuori magazzino
        iva: 22,
      };
    },

    // ✅ FUNZIONE UNIFICATA
    buildQuoteTable(quote, pageWidth, marginX) {
      const head = [
        [
          "Cod.",
          "Descrizione",
          "Scatole",
          "Q.tà",
          "U.m.",
          "Prezzo ivato",
          "Iva",
          "Importo ivato",
        ],
      ];
      const body = [];
      const righeIva = []; // per l'imponibile del riepilogo (sc-48721)

      // Sorgente righe (creazione: quote.items; fallback: quote.quote_items o formData.items)
      const rows =
        (Array.isArray(quote?.items) && quote.items.length
          ? quote.items
          : []) ||
        (Array.isArray(quote?.quote_items) && quote.quote_items.length
          ? quote.quote_items
          : []) ||
        (Array.isArray(this?.formData?.items) ? this.formData.items : []);

      const lower = (v) => String(v || "").toLowerCase();
      const getFromStore = (id, cat) => this.getItemFromStore?.(id, cat) || {};

      const resolveObj = (it) => {
        if (it.item) return it.item; // backend (magazzino)
        if (it.outstock) return it.outstock; // backend (fuori magazzino)
        // shape appiattita del form
        const cat =
          it.category || (it.outstockId ? "Fuori Magazzino" : "STOCK");
        const store = getFromStore(it.itemId || it.outstockId, cat);
        return { ...it, ...store };
      };

      // Stessa regola della UI: "marca - serie - colore - Tipo Posizione" per i
      // sanitari (sc-48197). withMeasure: qui la descrizione e' l'unico testo
      // della cella, quindi le piastrelle continuano a riportare la misura come
      // prima del refactor.
      const nameForPdf = (src) =>
        itemFullDescription(src, { withMeasure: true }) || "-";

      // Gruppi SOLO per category (outstock => FUORI MAGAZZINO)
      const catKeyFor = (it, src) => {
        const isOut = !!(
          it.outstock ||
          it.outstockId ||
          lower(src.category) === "fuori magazzino"
        );
        if (isOut) return "FUORI MAGAZZINO";
        const rawCat =
          it.item?.category ?? it.category ?? src.category ?? "generale";
        return String(rawCat).trim().toUpperCase();
      };

      const order = [];
      const groups = {};
      rows.forEach((it) => {
        const src = resolveObj(it);
        const k = catKeyFor(it, src);
        if (!groups[k]) {
          groups[k] = [];
          order.push(k);
        }
        groups[k].push({ it, src });
      });

      order.forEach((cat) => {
        // intestazione sezione
        body.push([
          {
            content: cat,
            colSpan: 8,
            styles: {
              fillColor: [235, 235, 235],
              fontStyle: "bold",
              halign: "left",
            },
          },
        ]);

        groups[cat].forEach(({ it, src }) => {
          const name = nameForPdf(src);
          const nameLC = name.toLowerCase();

          // Flag tipo riga
          const isOut = !!(
            it.outstock ||
            it.outstockId ||
            lower(src.category) === "fuori magazzino"
          );
          const isStockTiles =
            !isOut &&
            lower(it.item?.category || it.category || src.category) ===
              "piastrelle";
          const isOutTiles =
            isOut &&
            lower(
              it.outstock?.subCategory || it.subCategory || src.subCategory
            ) === "piastrelle";
          const isTiles = isStockTiles || isOutTiles;

          // ===== FIX quantità =====
          let qty = 0;
          // sc-48721: l'importo usa i mQ pieni, come totalPrice dell'API; la
          // Q.tà mostrata resta arrotondata. Altrimenti la somma della tabella
          // non torna col totale (es. 1 scatola da 1.5376 mQ).
          let qtyPiena = 0;
          let boxesDisplay = "";
          if (isStockTiles) {
            const sqmPerBox = Number(src.sqmPerBox || it.sqmPerBox || 0) || 0;
            const boxes = Number(it.boxQuantity || it.quantity || 0) || 0;
            boxesDisplay = boxes;
            qtyPiena = sqmPerBox ? boxes * sqmPerBox : boxes;
            qty = Number(qtyPiena.toFixed(2));
          } else if (isOut) {
            // Outstock (anche se piastrelle): NON usare box, prendi pieces/quantity
            qty = Number(it.pieces || it.quantity || 0) || 0;
          } else {
            // Stock non piastrelle
            qty = Number(it.pieces || it.quantity || it.boxQuantity || 0) || 0;
          }

          const unit = nameLC.includes("battiscopa")
            ? "mL"
            : isTiles
            ? "mQ"
            : "pz";
          const unitPrice = Number(it.price || 0) || 0;
          const iva = Number(it.iva ?? 22) || 22;
          if (!isStockTiles) qtyPiena = qty;
          const lineTotal = Number((unitPrice * qtyPiena).toFixed(2));
          righeIva.push({ importo: lineTotal, iva });
          const code = it.item?.code ?? it.code ?? src.code ?? "-";

          body.push([
            code,
            name,
            boxesDisplay === "" ? "" : String(boxesDisplay),
            String(qty),
            unit,
            `€ ${unitPrice.toFixed(2)}`,
            `${iva}%`,
            `€ ${lineTotal.toFixed(2)}`,
          ]);
        });
      });

      // Larghezze / colonne
      const usable = pageWidth - 2 * marginX;
      const w = {
        cod: 0.1,
        box: 0.11,
        qty: 0.1,
        um: 0.08,
        price: 0.16,
        iva: 0.08,
        tot: 0.17, // sc-48721: con Descrizione a min 40 mm la tabella resta di 190 mm
      };
      const cw = {
        0: Math.floor(usable * w.cod),
        2: Math.floor(usable * w.box),
        3: Math.floor(usable * w.qty),
        4: Math.floor(usable * w.um),
        5: Math.floor(usable * w.price),
        6: Math.floor(usable * w.iva),
        7: Math.floor(usable * w.tot),
      };

      return {
        // pdfSafeRows: descrizioni e codici arrivano dal DB, dove nessun livello
        // applicativo filtra i caratteri fuori cp1252 (cfr. utilities/pdfText.js)
        head: pdfSafeRows(head),
        body: pdfSafeRows(body),
        imponibile: totaliImponibile(righeIva),
        tableWidth: usable,
        margin: { left: marginX, right: marginX },
        columnStyles: {
          0: { cellWidth: cw[0], halign: "left" },
          1: { cellWidth: "auto", minCellWidth: 40 },
          2: { cellWidth: cw[2], halign: "right" },
          3: { cellWidth: cw[3], halign: "right" },
          4: { cellWidth: cw[4], halign: "center" },
          5: { cellWidth: cw[5], halign: "right" },
          6: { cellWidth: cw[6], halign: "right" },
          7: { cellWidth: cw[7], halign: "right" },
        },
      };
    },

    async onCreateQuoteAndGeneratePdf({
      generatePdf = true,
      sendEmail = false,
      skipCreate = false,
    } = {}) {
      // Cancelliamo eventuali auto-salvataggi pendenti
      if (typeof this.debouncedAutoSave?.cancel === "function") {
        this.debouncedAutoSave.cancel();
      }
      this.isAutoSavePending = false;

      this.errorMessage = "";
      this.successMessage = "";

      // 0) Validazioni minime
      if (!this.isAddressValid) {
        this.$toast.error("Inserisci un indirizzo di consegna.");
        return;
      }
      if (this.formData.items.length === 0) {
        this.errorMessage = "Aggiungi almeno un articolo prima di salvare";
        this.$toast.error(this.errorMessage);
        return;
      }

      // 1) Se hai un articolo parzialmente compilato nei campi input, aggiungilo prima del salvataggio
      if (
        (this.newItem.itemId || this.newItem.outstockId) &&
        (this.newItem.boxQuantity || this.newItem.pieces)
      ) {
        this.formData.items.push({ ...this.newItem });
      }

      let quote;
      let response;

      try {
        if (!skipCreate) {
          // 2) Salvataggio preventivo
          const payload = {
            ...this.formData,
            technical_queries: (this.formData.technical_queries || "").trim(),
            draftId: this.draftId, // Passiamo il draftId per l'eliminazione automatica al BE
            sendEmail, // Flag per l'invio email al cliente
          };

          const sanitize = (s) => (s || "").replace(/\p{C}+/gu, "");
          payload.technical_queries = sanitize(payload.technical_queries);
          // console.log("Creating quote with payload:", payload);
          response = await this.$store.dispatch("createQuote", payload);
          this.response = response; // mantengo per compatibilità col tuo codice
          // console.log("Create quote response:", response);

          if (response?.status !== 200 && response?.status !== 201) {
            // ⬇️ ramo 409
            if (
              response?.status === 409 &&
              response?.data.code === "QUOTE_DUPLICATE"
            ) {
              const d = response?.data || {};
              const details =
                (typeof d.details === "object" && d.details) || {};
              const id =
                details.quoteId ??
                details.id ??
                details.quote?.id ??
                d.quoteId ??
                d.id ??
                null;

              const address =
                details.address ?? this.formData?.location?.address ?? null;

              this.$toast.error(
                d.message ||
                  d.details ||
                  "Esiste già un preventivo per questo cliente allo stesso indirizzo in corso..."
              );
              this.openDuplicateModal(id, address);
              return;
            }

            // ...altri errori
            this.errorMessage =
              response.data?.details ||
              response.data?.message ||
              "Impossibile creare il preventivo.";
            this.$toast.error(this.errorMessage);
            this.successMessage = "";
            return;
          }

          // 3) Messaggio OK salvataggio
          this.successMessage =
            response.data?.message || "Preventivo creato con successo!";
          this.$toast.success(this.successMessage);

          // 3a) Caricamento oggetto quote per PDF
          const quoteWrap = response.data?.quote || {};
          quote = quoteWrap.newQuote;

          if (quote?.id) {
            this.newQuoteId = quote.id;
          }

          // Aspettiamo che Vue 2 flushi i watcher asincroni, poi resettiamo i flag
          await this.$nextTick();
          await this.$nextTick();
          if (typeof this.debouncedAutoSave?.cancel === "function") {
            this.debouncedAutoSave.cancel();
          }
          this.isDraftDirty = false;
          this.isPdfGenerated = true;
          this.isAutoSavePending = false;
        } else {
          // Solo invio: carichiamo i dati correnti dal server
          try {
            this.$toast.info("Recupero dati per invio email...");
            const res = await axiosInstance.get(`/quote/${this.newQuoteId}`);
            quote = res.data.quote;
            console.debug(
              "[onCreateQuoteAndGeneratePdf skipCreate] quote:",
              JSON.parse(JSON.stringify(quote || {}))
            );
            // In questo caso fittiziamo una "response" minima per il PDF logic
            response = { data: { quote: { newQuote: quote } } };
            this.isPdfGenerated = true;
          } catch (e) {
            console.error("Errore recupero preventivo per invio:", e);
            this.$toast.error("Impossibile recuperare i dati del preventivo");
            return;
          }
        }

        // 4) Se richiesto, genera + carica + scarica PDF
        if (generatePdf) {
          if (!quote) {
            this.errorMessage =
              "Dati preventivo non disponibili per la generazione del PDF.";
            this.$toast.error(this.errorMessage);
            this.successMessage = "";
            return;
          }
          const quoteWrap = response.data?.quote || {};
          const totalPrice = parseFloat(
            quoteWrap.totalPrice ?? quote.totalPrice ?? 0
          );

          // ================== GENERAZIONE PDF (stessa logica tua, solo adattata) ==================
          const doc = new jsPDF({ unit: "mm", format: "a4" });
          const pageWidth = doc.internal.pageSize.getWidth();
          const pageHeight = doc.internal.pageSize.getHeight();
          const marginX = 10;
          const marginY = 10;
          let y = marginY;

          const quoteClient =
            quote.Client ||
            this.clients.find(
              (c) =>
                String(c.id) === String(quote.clientId) ||
                String(c.id) === String(this.formData.clientId)
            ) ||
            null;
          const contactValue = quoteClient?.pec || quoteClient?.email || "";
          const contactLabel = quoteClient?.pec ? "pec" : "email";

          if (this.image) {
            try {
              doc.addImage(this.image, "PNG", marginX, y, 30, 30);
            } catch (err) {
              console.error("Logo non caricato", err);
            }
          }
          doc.setFontSize(9).setFont("helvetica", "normal");
          const headerLines = [
            "VIA SIRACUSA 83 - 96012  AVOLA  (SR)  - ITALIA ",
            "Tel. 3492253528 / 0931822066",
            "Email: emmamaison@libero.it",
          ];
          let headerY = y + 5;
          headerLines.forEach((text) => {
            const x = pageWidth - marginX - doc.getTextWidth(text);
            doc.text(text, x, headerY);
            headerY += 4;
          });

          y += 48;

          const printLabelValue = (
            label,
            value,
            xPos,
            yPos,
            maxWidth = null
          ) => {
            doc.setFont("helvetica", "bolditalic");
            doc.text(`${label}:`, xPos, yPos);
            const offset = doc.getTextWidth(`${label}: `) + 0.8;
            doc.setFont("helvetica", "normal");
            // pdfSafe: i dati cliente arrivano dal DB senza sanificazione lato API
            const val = pdfSafe(value, { fallback: "N/D" });
            if (maxWidth) {
              const wrapped = doc.splitTextToSize(val, maxWidth - offset);
              wrapped.forEach((ln, idx) =>
                doc.text(ln, xPos + offset, yPos + idx * 5)
              );
              return yPos + wrapped.length * 5;
            } else {
              doc.text(val, xPos + offset, yPos);
              return yPos + 5;
            }
          };

          // — Dettaglio cliente (SX)
          const leftX = marginX;
          doc
            .setFontSize(14)
            .setFont("helvetica", "bold")
            .text("Dettaglio cliente", leftX, y);
          let yLeft = y + 8;
          doc.setFontSize(11);
          const lh = (() => {
            const raw = quoteClient?.legalHeadquarters;
            if (!raw) return {};
            if (typeof raw === "object") return raw;
            try {
              return JSON.parse(raw);
            } catch {
              return {};
            }
          })();
          yLeft = printLabelValue(
            "codice cliente",
            quoteClient?.uniqueCode,
            leftX,
            yLeft
          );
          yLeft = printLabelValue(
            "cliente",
            quoteClient?.clientName,
            leftX,
            yLeft
          );
          yLeft = printLabelValue(
            "telefono",
            quoteClient?.phoneNumber,
            leftX,
            yLeft
          );
          yLeft = printLabelValue(contactLabel, contactValue, leftX, yLeft);
          yLeft = printLabelValue(
            "partita iva",
            quoteClient?.vatNumber,
            leftX,
            yLeft
          );
          yLeft = printLabelValue(
            "codice fiscale",
            quoteClient?.taxCode,
            leftX,
            yLeft
          );
          yLeft = printLabelValue(
            "azienda",
            quoteClient?.companyName,
            leftX,
            yLeft
          );
          yLeft = printLabelValue(
            "sede legale",
            lh.address,
            leftX,
            yLeft,
            pageWidth / 2 - 20
          );

          // — Dettaglio preventivo (DX)
          const rightX = pageWidth / 2 + 10;
          const colW = pageWidth - rightX - marginX;
          const formattedDate = new Date(quote.date).toLocaleDateString(
            "it-IT",
            {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            }
          );
          doc
            .setFontSize(14)
            .setFont("helvetica", "bold")
            .text("Dettaglio preventivo", rightX, y);
          let yRight = y + 8;
          doc.setFontSize(11);
          const loc = asLoc(quote.location) || {};
          yRight = printLabelValue("data", formattedDate, rightX, yRight);
          yRight = printLabelValue(
            "indirizzo di consegna",
            loc.address,
            rightX,
            yRight,
            colW
          );
          if (loc.link) {
            doc.setFont("helvetica", "bolditalic");
            doc.text("maps:", rightX, yRight);
            const off = doc.getTextWidth("maps: ") + 0.8;
            doc
              .setFont("helvetica", "bold")
              .setFontSize(10)
              .setTextColor(0, 0, 255);
            const safeLink = pdfSafe(loc.link);
            const disp =
              doc.getTextWidth(safeLink) > colW - off
                ? safeLink.slice(8, 27) + "…"
                : safeLink;
            doc.textWithLink(disp, rightX + off, yRight, { url: loc.link });
            doc.setTextColor(0).setFontSize(11).setFont("helvetica", "normal");
            yRight += 5;
          }

          y = Math.max(yLeft, yRight) + 4;
          doc.setDrawColor(150).line(marginX, y, pageWidth - marginX, y);
          y += 6;

          // — Tabella articoli (usa helper)
          const tbl = this.buildQuoteTable(quote, pageWidth, marginX);
          autoTable(doc, {
            startY: y,
            theme: "grid",
            styles: { fontSize: 10, cellPadding: 1.5 },
            headStyles: { fillColor: [200, 200, 200], fontStyle: "bold" },
            head: tbl.head,
            body: tbl.body,
            columnStyles: tbl.columnStyles,
            tableWidth: tbl.tableWidth,
            margin: tbl.margin,
          });
          y = (doc.lastAutoTable?.finalY || y) + 10;

          // — Riepilogo come un conto (sc-48721)
          const footerBlockHeight = 55;
          if (pageHeight - y < footerBlockHeight) {
            doc.addPage();
            y = marginY;
          }
          y = disegnaRiquadroRiepilogo(doc, {
            y,
            pageWidth,
            marginX,
            righe: righeRiepilogo(
              calcolaImporti({ ...quote, totalPrice }),
              tbl.imponibile
            ),
          });

          if (quote.technical_queries) {
            if (pageHeight - y < 20) {
              doc.addPage();
              y = marginY;
            }
            doc.setFont("helvetica", "italic").setFontSize(8);
            // Note libere: e' il campo piu' esposto a testo incollato da Word/web
            const txt = doc.splitTextToSize(
              pdfSafe(quote.technical_queries),
              pageWidth - 2 * marginX
            );
            doc.text(txt, marginX, y);
          }

          const quoteId = quote.id;
          // const filename = `Preventivo_N_${quoteId}.pdf`;
          // const blob = doc.output("blob");

          const filenameBase = `Preventivo_N_${quoteId}.pdf`;
          const isDev =
            process.env.NODE_ENV === "development" ||
            import.meta?.env?.MODE === "development" ||
            process.env?.VUE_APP_NODE_ENV === "development";

          // helper FE (senza 'path')
          const withSuffixBeforeExt = (filename, suffix) => {
            if (!suffix) return filename;
            const dot = filename.lastIndexOf(".");
            if (dot <= 0) return `${filename}.${suffix}`;
            return `${filename.slice(0, dot)}.${suffix}${filename.slice(dot)}`;
          };

          const finalName = withSuffixBeforeExt(
            filenameBase,
            isDev ? "dev" : ""
          );
          const blob = doc.output("blob");
          // 👇 crea un "File" con nome giusto, così Multer lo vede come originalname
          const file = new File([blob], finalName, { type: "application/pdf" });

          try {
            const uploadResp = await this.$store.dispatch(
              "uploadQuoteDocument",
              {
                quoteId,
                document: file,
                filename: finalName,
              }
            );
            this.lastUploadedDocName = uploadResp.data.doc.name;
          } catch (error) {
            console.error("Errore durante l'upload del PDF:", error);
            this.$toast.error(
              error.response?.data?.details ||
                error.response?.data?.error ||
                "Errore durante il caricamento del PDF."
            );
            return;
          }

          // Scarica sempre il PDF localmente
          doc.save(finalName);
          this.$toast.success("PDF generato correttamente");
        }
      } catch (error) {
        const resp = error?.response;

        // ⬇️ ramo 409
        if (resp?.status === 409 && resp?.data?.code === "QUOTE_DUPLICATE") {
          const d = resp?.data || {}; // usa quello che hai a disposizione
          const details = (typeof d.details === "object" && d.details) || {};
          const id =
            details.quoteId ??
            details.id ??
            details.quote?.id ??
            d.quoteId ??
            d.id ??
            null;

          const address =
            details.address ?? this.formData?.location?.address ?? null;

          this.$toast.error(
            d.message ||
              d.details ||
              "Esiste già un preventivo per questo cliente allo stesso indirizzo in corso..."
          );
          this.openDuplicateModal(id, address);
          return;
        }

        // ...altri errori
        this.errorMessage =
          resp?.data?.message ||
          resp?.data?.details ||
          resp?.data?.error ||
          "Errore durante la creazione del preventivo.";
        this.$toast.error(this.errorMessage);
        this.successMessage = "";
      }
    },

    fetchItems(q) {
      axiosInstance
        .get("/item/get-all", { params: { page: 1, limit: 10, search: q } })
        .then(({ data }) => {
          this.filteredItems = data.results;
        })
        .catch(console.error)
        .finally(() => (this.itemsLoading = false));
    },
    fetchOutstocks(q) {
      axiosInstance
        .get("/outstock/get-all", { params: { page: 1, limit: 10, search: q } })
        .then(({ data }) => {
          this.filteredOutstock = data.results;
        })
        .catch(console.error)
        .finally(() => (this.outLoading = false));
    },

    // --- pulizia selezione articolo di magazzino ---
    clearItemSelection() {
      const iva = this.newItem.iva || 22; // preserva l'IVA scelta
      Object.assign(this.newItem, this.resetNewItem(), { iva });
      this.searchQueryItem = "";
    },

    // --- pulizia selezione fuori magazzino ---
    clearOutstockSelection() {
      const iva = this.newItem.iva || 22;
      Object.assign(this.newItem, this.resetNewItem(), { iva });
      // this.formData.outstockId = null;
      this.searchQueryOutstock = "";
    },
  },

  watch: {
    formData: {
      deep: true,
      handler() {
        this.isDraftDirty = true;
        this.isPdfGenerated = false; // Le modifiche invalidano il PDF generato
        this.isAutoSavePending = true;
        this.debouncedAutoSave();
      },
    },
    "formData.clientId": {
      immediate: true,
      handler(newId) {
        if (newId) {
          const c = (this.clients || []).find(
            (x) => String(x.id) === String(newId)
          );
          if (c) {
            this.searchQueryClient = c.email
              ? `${c.clientName} - (${c.email})`
              : `${c.clientName} - (${c.pec})`;
          }
        }
      },
    },
    clients: {
      immediate: true,
      handler(newList) {
        if (this.formData.clientId) {
          const c = (newList || []).find(
            (x) => String(x.id) === String(this.formData.clientId)
          );
          if (c) {
            this.searchQueryClient = c.email
              ? `${c.clientName} - (${c.email})`
              : `${c.clientName} - (${c.pec})`;
          }
        }
      },
    },
    searchQueryClient() {
      this.isAutoSavePending = true;
      this.debouncedAutoSave();
    },
    // 🔄 Ricerca + pulizia selezione se l'utente svuota il campo
    searchQueryItem(newQ, oldQ) {
      // se l'utente ha cancellato il testo ed era selezionato un articolo → pulisci
      if (oldQ && !newQ.trim() && this.newItem.itemId)
        this.clearItemSelection();

      if (!newQ.trim()) {
        // niente testo: torna ai primi articoli (get-all senza filtro)
        this.debouncedFetchItems("");
        return;
      }
      this.debouncedFetchItems(newQ);
    },

    // Se usi la ricerca anche per gli outstock, aggiungi questo:
    searchQueryOutstock(newQ, oldQ) {
      if (oldQ && !newQ.trim() && this.newItem.outstockId)
        this.clearOutstockSelection();

      if (!newQ.trim()) {
        this.filteredOutstock = this.defaultOutstocks();
        return;
      }
      this.debouncedFetchOutstocks(newQ);
    },

    // sia searchQueryItem che searchQueryOutstock non servono più, si possono rimuovere

    // watch per svuotare i campi quando si cambia la sottocategoria
    "newOutstock.subCategory"(val) {
      if (val === "piastrelle") {
        // pulisci campi non pertinenti
        this.newOutstock.brand = "";
        this.newOutstock.subBrand = "";
        // this.newOutstock.quantity = null;
        this.newOutstock.price = null;
      } else if (val === "sanitari" || val === "altro") {
        this.newOutstock.itemName = "";
        // this.newOutstock.sqmQuantity = null;
        this.newOutstock.sqmPrice = null;
        this.newOutstock.widthCm = null;
        this.newOutstock.heightCm = null;
      }
    },

    // 🔒 mutua esclusione (come già facevi)
    "newItem.itemId"(v) {
      if (v) {
        this.newItem.outstockId = null;
        this.searchQueryOutstock = "";
      }
    },
    "newItem.outstockId"(v) {
      if (v) {
        this.newItem.itemId = null;
        this.searchQueryItem = "";
      }
    },

    // "formData.outstockId"(v) {
    //   if (!v) return;
    //   this.newItem.outstockId = v;
    //   this.newItem.itemId = null;
    // },

    canSaveCreate(val) {
      console.debug("[canSaveCreate]", val, {
        items: this.formData.items?.length ?? 0,
        location: JSON.parse(JSON.stringify(this.formData.location ?? {})),
        isAddressValid: this.isAddressValid,
      });
    },

    "newItem.iva"(val) {
      if (this.newItem.itemId) {
        const base = this.getItemFromStore(this.newItem.itemId, "STOCK").price;
        this.newItem.price = this.adjustedPrice(base, val);
        return;
      }
      if (this.newItem.outstockId) {
        const outstock = this.getItemFromStore(
          this.newItem.outstockId,
          "Fuori Magazzino"
        );
        const base =
          outstock.subCategory === "piastrelle"
            ? outstock.sqmPrice
            : outstock.price;
        this.newItem.unitPrice = Number(this.adjustedPrice(base, val));
        const qty = this.newItem.pieces || 0;
        this.newItem.price = (this.newItem.unitPrice * qty).toFixed(2);
      }
    },

    // aggiornamento riga esistente (come avevi)
    newItem: {
      deep: true,
      handler(nv) {
        if (!nv) return;

        // Trova la riga esistente in base all'id correntemente selezionato
        const id = nv.outstockId ?? nv.itemId;
        // console.log({ nv: nv, id: id });
        if (!id) return;

        const key = nv.outstockId ? "outstockId" : "itemId";
        // console.log("key", key);
        // console.log("formdata", this.formData.items);
        const row = this.formData.items.find((x) => x[key] === id);
        // console.log("row", row);

        // Se non è stata ancora aggiunta con addItem(), non toccare nulla
        if (!row) return;

        // Calcolo quantità in base al tipo cliccato ora
        const isStockTiles = this.selectedItem.category === "piastrelle";
        // const isOutTiles =
        //   this.selectedItem.category === "Fuori Magazzino" &&
        //   this.selectedItem.subCategory === "piastrelle";

        // Aggiorna SOLO i campi che esistono nelle righe
        row.boxQuantity = isStockTiles ? nv.boxQuantity || 0 : 0;
        row.pieces = isStockTiles ? 0 : nv.pieces || 0;
        row.price = nv.price;
        row.iva = nv.iva;
        // console.log("row after update", row);
      },
    },
    // newItem: {
    //   handler(nv) {
    //     if (!nv.itemId && !nv.outstockId) return;
    //     console.log("formdata", this.formData);
    //     // const row =
    //     //   nv.category === "Fuori Magazzino"
    //     //     ? this.formData.items.find((x) => x.outstockId === nv.outstockId)
    //     //     : this.formData.items.find((x) => x.itemId === nv.itemId);
    //     // console.log("nv", nv);
    //     // console.log("row", row);
    //     // if (!row) return;
    //     let row = null;
    //     if (nv.outstockId) {
    //       row = this.formData.items.find((x) => x.outstockId === nv.outstockId);
    //       console.log("nv", nv);
    //       console.log("row", row);
    //     } else if (nv.itemId) {
    //       row = this.formData.items.find((x) => x.itemId === nv.itemId);
    //       console.log("nv", nv);
    //       console.log("row", row);
    //     } else {
    //       return; // nessun id ⇒ niente da aggiornare
    //     }
    //     console.log("selecteditem", this.selectedItem);
    //     const qty =
    //       this.selectedItem.category === "piastrelle"
    //         ? nv.boxQuantity
    //         : this.selectedItem.subCategory === "piastrelle"
    //         ? nv.sqmQuantity
    //         : nv.pieces || 0;
    //     row.quantity = qty;
    //     row.boxQuantity = nv.boxQuantity;
    //     row.pieces = nv.pieces;
    //     row.price = nv.price;
    //     row.iva = nv.iva;
    //   },
    //   deep: true,
    // },

    showDuplicateModal(v) {
      if (
        v &&
        this.lastDuplicateQuoteInfo &&
        this.lastDuplicateQuoteInfo.quoteId
      ) {
        this.loadDuplicateQuote();
      }
    },
    lastDuplicateQuoteInfo: {
      deep: true,
      handler(nv) {
        if (this.showDuplicateModal && nv && nv.quoteId) {
          this.loadDuplicateQuote();
        }
      },
    },
  },

  mounted() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },

  beforeUnmount() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },
};
</script>

<style src="@/css/CreateQuotePage.css"></style>
